export default {
    /*
    |--------------------------------------------------------------------------
    | Rounded Elements
    |--------------------------------------------------------------------------
    |
    | Boolean
    |
    */

    'rounded_elements': false,
};